import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import { useQueryClient } from "react-query";
import { setupPayment, SetupPaymentProps } from "../services/payments";
import { PaymentMethodType } from "../types";

export const usePaymentSetup = <T extends PaymentMethodType>(
  props: SetupPaymentProps<T> & {
    enabled?: boolean;
    onError?: (error: Error) => void;
  }
) => {
  const queryClient = useQueryClient();
  const {
    data: setupConfig,
    isLoading,
    isSuccess,
    isError,
  } = useDataQuery(
    ["paymentSetupConfig", props],
    async () => {
      try {
        const data = await setupPayment(props);

        return data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    {
      enabled: props.enabled ?? true,
      onError: (error: Error) => {
        setTimeout(() => {
          props.onError(error);
        }, 1000);
      },
      retry: false,
    }
  );

  const invalidate = () => {
    queryClient.invalidateQueries(["paymentSetupConfig", props]);
  };

  return {
    setupConfig,
    isLoading,
    isSuccess,
    isError,
    invalidate,
  };
};
